import React, { useState, useEffect, useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import * as api from "api/endpoints/workflowReport";
import { loadEpHistory, clearEpHistory, loadEpExport } from "store/slices/reportsPage";
import { selectHistoryData, selectHistoryError } from "store/slices/reportsPage";

import { selectUser } from "store/slices/app";
import ApiUsageReportsMain from "components/reports/apiUsageReports/ApiUsageReportMain";

const ApiUsageReportsPage = () => {
  const dispatch = useDispatch();

  const [selectedRow, setSelectedRow] = useState();
  const [historyPageNo, setHistoryPageNo] = useState({ pageNo: 1 });

  const historyData = useSelector(selectHistoryData);
  const historyError = useSelector(selectHistoryError);
  const userData = useSelector(selectUser);

  const [apiUsageData, setApiUsageData] = useState([]);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [pageState, setPageState] = useState(1);
  const [epId, setEpId] = useState(userData.selectedPartner.id);

  const reportType = "A";

  useEffect(() => {
    setEpId(userData.selectedPartner.id);
    setPageState(1);
  }, [userData.selectedPartner.id]);

  const loadApiUsageCallback = useCallback(loadApiUsageData, [pageState, epId]);

  useEffect(() => {
    loadApiUsageCallback();
  }, [loadApiUsageCallback]);

  function handleHistoryClick(selectedRow) {
    dispatch(loadEpHistory(selectedRow.partnerReportsId, historyPageNo.pageNo));
    setHistoryDialogOpen(true);
    setSelectedRow(selectedRow);
  }

  function closeHistoryDialogHandler() {
    setHistoryDialogOpen(false);
    dispatch(clearEpHistory());
  }

  function onHistoryPageChange(event, newPage) {
    dispatch(loadEpHistory(selectedRow.partnerReportsId, newPage));
    setHistoryPageNo({ pageNo: 1 });
  }

  async function handleDownload(partnerReportsId) {
    dispatch(loadEpExport(partnerReportsId));
  }

  function handlePageChange(e, value) {
    setPageState(value);
  }

  async function loadApiUsageData() {
    const config = {
      params: {
        pageNo: pageState,
        pageSize: 10,
        reportType: reportType,
        epId: epId
      }
    };
    const ApiUsageData = await api.getReports(config);
    setApiUsageData(ApiUsageData);
  }

  const pagination = {
    page: pageState,
    count: apiUsageData.page_count,
    onChange: handlePageChange
  };

  return (
    <Box>
      <ApiUsageReportsMain
        data={apiUsageData}
        pagination={pagination}
        historyData={historyData}
        historyError={historyError}
        historyDialogOpen={historyDialogOpen}
        reportName={selectedRow?.name}
        historyPageNo={historyPageNo}
        onDownload={handleDownload}
        onHistoryClick={handleHistoryClick}
        onPageChange={handlePageChange}
        onHistoryPageChange={onHistoryPageChange}
        closeHistoryDialogHandler={closeHistoryDialogHandler}
      />
    </Box>
  );
};

export default ApiUsageReportsPage;
